// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subscription-container {
  height: calc(100vh - 80px);
  overflow: auto;
  padding: 50px 80px 10px 80px;
}
#subscription-container .subscription-block {
  width: 320px;
}
#subscription-container .subscription-block-dark {
  width: 320px;
  background: #121432;
  border-radius: 20px;
  height: -moz-fit-content;
  height: fit-content;
}
#subscription-container .subscription-block-dark:hover {
  background: #20223f;
}
#subscription-container .sub-block {
  border-radius: 20px;
}
#subscription-container .sub-block:hover {
  border: 1px solid var(--56ff) !important;
  box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.0392156863);
}
#subscription-container .sub-block-dark {
  border-radius: 20px;
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#subscription-container .sub-block-dark .dark-card-sub {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 20px;
  padding: 20px;
}
#subscription-container .sub-block-dark .dark-card-sub:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}
#subscription-container .active-sub-text {
  display: none;
}
#subscription-container .active-sub-text-dark {
  display: none;
}
#subscription-container .active-sub {
  position: relative;
  overflow: hidden;
}
#subscription-container .active-sub .sub-block {
  border: 1px solid var(--56ff) !important;
}
#subscription-container .active-sub .active-sub-text {
  position: absolute;
  left: 43%;
  top: 2.2%;
  background-color: var(--56ff);
  color: var(--ffff);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(41deg);
}
#subscription-container .active-sub .active-sub-text-dark {
  position: absolute;
  left: 43%;
  top: 2.2%;
  background-color: var(--ffff);
  color: var(--56ff);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(41deg);
}
#subscription-container .dropdown {
  width: 100%;
  display: flex !important;
}
#subscription-container .dropdown-menu {
  transform: translate(115px, 48px) !important;
}
#subscription-container #new-get-started {
  width: 100%;
  background-color: var(--56ff);
  border: 1px solid var(--56ff);
  color: var(--ffff);
  min-height: 46px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
}
#subscription-container #new-get-started::after {
  display: none;
}
#subscription-container .customTier {
  border-radius: 10px;
  width: 100%;
  padding: 20px 20px 20px 20px;
}
#subscription-container .customTier-dark {
  border-radius: 10px;
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#subscription-container .customTier-dark .dark-customTier {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 10px;
  padding: 10px;
}
#subscription-container .customTier-dark .dark-customTier:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}`, "",{"version":3,"sources":["webpack://./src/pages/Subscription/Subscription.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,cAAA;EACA,4BAAA;AACF;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;AAEJ;AADI;EACE,mBAAA;AAGN;AAAE;EACE,mBAAA;AAEJ;AADI;EACE,wCAAA;EACA,yDAAA;AAGN;AAAE;EACE,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAFJ;AAGI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AAJN;AAMI;EACE,uFAAA;AAJN;AAUE;EACE,aAAA;AARJ;AAUE;EACE,aAAA;AARJ;AAUE;EACE,kBAAA;EACA,gBAAA;AARJ;AASI;EACE,wCAAA;AAPN;AAYI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AAVN;AAYI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AAVN;AAaE;EACE,WAAA;EACA,wBAAA;AAXJ;AAaE;EACE,4CAAA;AAXJ;AAaE;EACE,WAAA;EACA,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAXJ;AAYI;EACE,aAAA;AAVN;AAaE;EACE,mBAAA;EACA,WAAA;EACA,4BAAA;AAXJ;AAaE;EACE,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAfJ;AAgBI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AAjBN;AAmBI;EACE,uFAAA;AAjBN","sourcesContent":["#subscription-container {\r\n  height: calc(100vh - 80px);\r\n  overflow: auto;\r\n  padding: 50px 80px 10px 80px;\r\n  .subscription-block {\r\n    width: 320px;\r\n  }\r\n  .subscription-block-dark {\r\n    width: 320px;\r\n    background: #121432;\r\n    border-radius: 20px;\r\n    height: fit-content;\r\n    &:hover {\r\n      background: #20223f;\r\n    }\r\n  }\r\n  .sub-block {\r\n    border-radius: 20px;\r\n    &:hover {\r\n      border: 1px solid var(--56ff) !important;\r\n      box-shadow: 0px 20px 40px 0px #0000000a;\r\n    }\r\n  }\r\n  .sub-block-dark {\r\n    border-radius: 20px;\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .dark-card-sub {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 20px;\r\n      padding: 20px;\r\n    }\r\n    .dark-card-sub:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n  .active-sub-text {\r\n    display: none;\r\n  }\r\n  .active-sub-text-dark {\r\n    display: none;\r\n  }\r\n  .active-sub {\r\n    position: relative;\r\n    overflow: hidden;\r\n    .sub-block {\r\n      border: 1px solid var(--56ff) !important;\r\n    }\r\n    .sub-block-dark {\r\n      // border: 1px solid var(--ffff) !important;\r\n    }\r\n    .active-sub-text {\r\n      position: absolute;\r\n      left: 43%;\r\n      top: 2.2%;\r\n      background-color: var(--56ff);\r\n      color: var(--ffff);\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transform: rotate(41deg);\r\n    }\r\n    .active-sub-text-dark {\r\n      position: absolute;\r\n      left: 43%;\r\n      top: 2.2%;\r\n      background-color: var(--ffff);\r\n      color: var(--56ff);\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transform: rotate(41deg);\r\n    }\r\n  }\r\n  .dropdown {\r\n    width: 100%;\r\n    display: flex !important;\r\n  }\r\n  .dropdown-menu {\r\n    transform: translate(115px, 48px) !important;\r\n  }\r\n  #new-get-started {\r\n    width: 100%;\r\n    background-color: var(--56ff);\r\n    border: 1px solid var(--56ff);\r\n    color: var(--ffff);\r\n    min-height: 46px;\r\n    border-radius: 10px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    line-height: 19px;\r\n    &::after {\r\n      display: none;\r\n    }\r\n  }\r\n  .customTier {\r\n    border-radius: 10px;\r\n    width: 100%;\r\n    padding: 20px 20px 20px 20px;\r\n  }\r\n  .customTier-dark {\r\n    border-radius: 10px;\r\n    width: 100%;\r\n    padding: 20px 20px 20px 20px;\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .dark-customTier {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 10px;\r\n      padding: 10px;\r\n    }\r\n    .dark-customTier:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
